// Khmer translations
export const km: Record<string, string> = {
  'menu.dashboard': 'ផ្ទាំងគ្រប់គ្រង',
  'menu.customers': 'អតិថិជន',
  'menu.products': 'ផលិតផល',
  'menu.users': 'អ្នកប្រើប្រាស់',
  'menu.settings': 'ការកំណត់',
  'menu.logout': 'ចាកចេញ',
  'dashboard.title': 'ផ្ទាំងគ្រប់គ្រង',
  'dashboard.newOrder': 'ការបញ្ជាទិញថ្មី',
  'order.title': 'ការបញ្ជាទិញថ្មី',
  'order.customer': 'អតិថិជន',
  'order.products': 'ផលិតផល',
  'order.total': 'សរុប',
  'users.title': 'អ្នកប្រើប្រាស់',
  'users.name': 'ឈ្មោះ',
  'users.email': 'អ៊ីមែល',
  'common.yes': 'បាទ/ចាស',
  'common.no': 'ទេ',
  'common.cancel': 'បោះបង់',
  'common.save': 'រក្សាទុក',
  'common.search': 'ស្វែងរក',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'ចូល',
  'login.welcome': 'សូមស្វាគមន៍, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'អ៊ីមែល',
  'signup.phone': 'ទូរសព្ទ',
  'menu.reportsAndAccounting': 'របាយការណ៍ និងគណនេយ្យ',
  'menu.systemAndCommunication': 'ប្រព័ន្ធ និងទំនាក់ទំនង',
};